export const TRIAL_PAGES_TOUR_BOOST = 'tour_boost';
